import { Footer } from "@vwfs-bronson/bronson-react";
import { Footnotes } from "./Footnotes";
import CHI, { CHIpaths } from "./CustomerHappinessIndex/CHI";
import { getStorefrontData } from "@services/redux/features/storefront.redux";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import { JourneyRoutes } from "@common/models/enums";
import { useTranslation } from "react-i18next";

interface PageFooterReduxProps {
  storefrontData: any;
}

const PageFooter: React.FC<PageFooterReduxProps> = ({ storefrontData }) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const splittedPath = pathname.split("/")?.pop();

  const showCHI = () => CHIpaths.includes(splittedPath as JourneyRoutes);

  const year = new Date().getFullYear();

  return (
    <>
      {showCHI() && <CHI />}
      <Footer>
        <Footer.ModuleBreadcrumbs />
        <Footer.ModuleMetaNav copyrightText={t("footer:copyrightText", { year })} metaSectionLabel={t("footer:metaSectionLabel")}>
          {t("footer:metaNavItems", { returnObjects: true})?.map((item: any, index: number) => (
              <Footer.ModuleMetaNav.Item href={item.url} normalLink={true} linkProps={{ target: "_blank" }} >
                {item.text}
              </Footer.ModuleMetaNav.Item>
          ))}
        </Footer.ModuleMetaNav>
        <Footer.ModuleFootnotes>
          <Footnotes />
        </Footer.ModuleFootnotes>
      </Footer>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    storefrontData: getStorefrontData(state),
  };
};
export default connect(mapStateToProps)(PageFooter);
